export default __webpack_public_path__ + "static/media/usfda_response- Instructions for use .89846b9e.pdf";